import type {
  ShipNodePairingCode,
  ShipNodeStation,
  ShipNodeStationsService,
} from '@skupreme/shared/components/shipnode';
import { APIPath } from '../constants/api';
import { BaseService } from './base';

/* The EN-3274 station backend for one warehouse, through wms-api's routes (EN-3277). wms-api checks that the
   warehouse belongs to the signed-in user's organization, then calls skupreme-api with its service key. */

export function createWarehouseShipNodeService(
  warehouseId: string,
): ShipNodeStationsService {
  const base = `${APIPath.warehouses}/${encodeURIComponent(warehouseId)}/shipnode`;
  const stationPath = (stationId: string) =>
    `${base}/stations/${encodeURIComponent(stationId)}`;

  return Object.freeze({
    createPairingCode: (stationName?: string) =>
      BaseService.post<ShipNodePairingCode>(
        `${base}/pairing-codes`,
        stationName ? { station_name: stationName } : {},
      ),
    listStations: () =>
      BaseService.get<{ stations: ShipNodeStation[] }>(`${base}/stations`),
    removeStation: (stationId: string) => BaseService.remove(stationPath(stationId)),
    setPrinterEnabled: (stationId: string, printerId: string, enabled: boolean) =>
      BaseService.put(
        `${stationPath(stationId)}/printers/${encodeURIComponent(printerId)}`,
        { enabled },
      ),
    sendTestPage: (stationId: string, printerId: string) =>
      BaseService.post(`${stationPath(stationId)}/test-page`, {
        printer_id: printerId,
      }),
  });
}
